import ArticleList, {
    GeneralArticleList,
    MoreInArticleList,
} from './ArticleList';

export { GeneralArticleList, MoreInArticleList };
export default ArticleList;
